export class SampleWebhookPayload {
    constructor(guid: string) {
        this.eventId = 'SampleEventId-' + guid;
    }

    webhookId = 'SampleWebhookId123';
    eventId = "SampleEventId-";
    url = '';
    eventBasis = '';
    eventSubject = '';
    eventAction = '';
    basisId = 'SampleBasisId456';
    subjectId = 'SampleSubjectId789';
    eventDate = new EventDate();
}
class EventDate {
    dateTime = (new Date()).toISOString();
    timeZone = 'Universal';
}